module.exports = __webpack_public_path__ + "img/Ktirio-Nrg.663c2643.jpg";